module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_pie_2.b83a4aa5.jpg";